import { Meta } from '@components/atoms/MetaTags/Meta';
import { CookiesComplete } from '@components/organisms/Cookies/CookiesComplete';
import { getCookie } from '@utils/cookies';
import { useDatalayer } from '@vgn-medien-holding/vgn-fe-components';
import { Oewa } from 'components/atoms/Oewa/Oewa';
import { Default } from 'components/templates/layouts/Default';
import Head from 'next/head';

export default function CookiesPage() {
  const title = 'Cookie-Liste';
  const description =
    'Diese Website verwendet Cookies und ähnliche Technologien. Hier finden Sie eine detaillierte Übersicht über alle auf dieser Website verwendeten Cookies.';

  useDatalayer({
    seitentyp: 'Service',
    event: 'metadata',
    loginStatus: 'nicht eingeloggt',
    oewaSeitenkontingent: 'Service',
    oewaSubkontingent: 'Sonstiges',
    oewaProfilingkontingent: 'Sonstiges',
    cookieAlert: getCookie('OptanonConsent'),
  });

  return (
    <>
      <Oewa pageKey="Sonstiges" categoryKey="Service" profileKey="Sonstiges" />
      <Head>
        <title>Cookie-Liste | TV-MEDIA</title>
        {Meta(
          {
            meta_title: 'Cookie-Liste | TV-MEDIA',
            meta_description:
              'Diese Website verwendet Cookies und ähnliche Technologien. Hier finden Sie eine detaillierte Übersicht über alle auf dieser Website verwendeten Cookies.',
          },
          'Cookie-Liste | TV-MEDIA',
        )}
      </Head>
      <article className="relative mx-auto w-full min-w-0 max-w-[1090px] px-6 py-8 text-foreground md:px-20 lg:px-32">
        <CookiesComplete title={title} description={description} />
      </article>
    </>
  );
}

CookiesPage.PageLayout = Default;
